import { Effects } from 'chessboard/plugins/effects/renderer/types';

export const gamechanger = `<path class="${Effects.ClassNames.Shadow}" opacity="0.3" d="M9,.5a9,9,0,1,0,9,9A9,9,0,0,0,9,.5Z"></path>
<path class="${Effects.ClassNames.Background}" fill="#7979a1" d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z"></path>
<g class="${Effects.ClassNames.ComponentShadow}" opacity="0.1">
    <polygon points="11.29 11.34 11.29 8.56 7.79 11.3 7.79 11.34 5.39 11.34 9.54 16.5 13.73 11.34 11.29 11.34"></polygon>
    <polygon points="7.83 7.51 7.83 10.32 11.33 7.58 11.33 7.5 13.73 7.5 9.58 2.35 5.39 7.51 7.83 7.51"></polygon>
  </g>
<g>
    <polygon class="${Effects.ClassNames.Component}" fill="#fff" points="10.9 10.92 10.9 8.13 7.4 10.87 7.4 10.92 5 10.92 9.15 16.07 13.34 10.92 10.9 10.92"></polygon>
    <polygon class="${Effects.ClassNames.Component}" fill="#fff" points="7.44 7.08 7.44 9.9 10.94 7.16 10.94 7.08 13.34 7.08 9.19 1.93 5 7.08 7.44 7.08"></polygon>
  </g>`;
